import React from "react";
import SidebarAdmin from "../../menu/SidebarAdmin";
import Topbar from "../../menu/Topbar";
import FormularioAddUsuarios from "../../Formulario/FormularioAddUsuarios";
import { useParams } from "react-router-dom";

const AddUsuarios = () => {
  const { id } = useParams();
  const [menuClose, setMenuClose] = React.useState(false);

  const toggleMenu = () => setMenuClose((prev) => !prev);

  const isEdit = Boolean(id);

  return (
    <div className="app-container">
      <SidebarAdmin close={menuClose} />

      <main className="main-content">
        <Topbar
          page={isEdit ? "Editar Usuário / Licenciado" : "Adicionar Usuários / Licenciados"}
          onToggleMenu={toggleMenu}
        />

        <section className="content">
          <div className="page-header">
            <h2>{isEdit ? "Editar dados do licenciado" : "Dados do licenciado"}</h2>
            <p>
              {isEdit
                ? "Atualize as informações do licenciado e salve novamente."
                : "Preencha as informações principais para acesso ao painel de licenciado."}
            </p>
          </div>

          <div className="card">
            <FormularioAddUsuarios />
          </div>
        </section>
      </main>
    </div>
  );
};

export default AddUsuarios;
